import { IconReturn, TERMINOLOGY_ICONS } from "./useTerminologyIcons.js";
import { TERMINOLOGY, TextReturn } from "./useTerminologyText.js";

export type TerminologyReturn = TextReturn & IconReturn;

export function useTerminology(): TerminologyReturn {
  return { ...TERMINOLOGY, ...TERMINOLOGY_ICONS };
}
